import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import Config from '~/config';
// import '@australiangreens/theme/all/all.css';
import '@australiangreens/theme/fed21/all/all.css';
// import '@australiangreens/theme/qld/global.css';
// import '@australiangreens/theme/qld/fa.css';
import AppWrapper from '~/components/wrappers/AppWrapper/AppWrapper';
import * as serviceWorker from '~/serviceWorker';
import { createRoot } from 'react-dom/client';

ReactGA.initialize(Config.googleAnalyticsCode, { debug: Config.env === 'dev' });

const root = createRoot(document.getElementById('root'));
root.render(<AppWrapper />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
